module.exports = __webpack_public_path__ + "static/media/error.2343acb.mp3";